import React, {useEffect} from 'react'
import './Preloader.scss'
import cn from "classnames";
import preloaderImg from "../../img/preloader_.svg";

function Preloader ({isLoaded, setIsLoaded, time= 2000}) {

  useEffect(()=> {
    setTimeout(()=> {
      setIsLoaded(true)
    },time)
  },[])

  return (
    <div className={cn(
      'loader',
      isLoaded && 'disabled'
    )}>
      <div className="loaderBg">
        <img className='preloader-icon' src={preloaderImg} alt=""/>
      </div>
    </div>
  )
}

export default Preloader